export const EMPLOYERS_DEFAULT_PIN_SETTINGS_FORM_VALUES = {
    pinLength: 'Eight_Digits',
    firstPinDigits: 'Last_Four_Of_SSN',
    lastPinDigits: 'Birth_Year',
};
//# sourceMappingURL=employer.js.map